// import { createFilter as createFilterFn } from 'redux-persist-transform-filter';
// import { ReduxRootState } from '../store';
// function createFilter<S, M>(store: keyof S, keys: Array<keyof M>) {
//   return createFilterFn(store as string, keys as string[]);
// }
// const sessionFilter = createFilter<ReduxRootState, SessionState>('session', [
//   'isAuthenticated',
// ]);
export var persistFilters = [];
